import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyB_awHo_jOxKVHvIKlWTVKLUfY_q74fz6A',
  authDomain: 'gateway-2f9cd.firebaseapp.com',
  projectId: 'gateway-2f9cd',
  storageBucket: 'gateway-2f9cd.firebasestorage.app',
  messagingSenderId: '748031607904',
  appId: '1:748031607904:web:2e5b8f09e70c7821c3ef05',
};

// VAPID key from Firebase Console → Project Settings → Cloud Messaging → Web Push certificates
const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY ?? '';

let messaging = null;

try {
  const app = initializeApp(firebaseConfig);
  messaging  = getMessaging(app);
} catch (e) {
  console.warn('[FCM] Init failed:', e);
}

export async function requestPushPermission() {
  if (!messaging || !('Notification' in window) || !('serviceWorker' in navigator)) return null;

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    const sw = await navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' });
    await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey:         VAPID_KEY,
      serviceWorkerRegistration: sw,
    });

    return token ?? null;
  } catch (err) {
    console.warn('[FCM] Failed to get push token:', err);
    return null;
  }
}

export function onForegroundMessage(callback) {
  if (!messaging) return () => {};
  return onMessage(messaging, callback);
}
